module.exports = __webpack_public_path__ + "static/media/tranquil_living_2.84eee5a1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/projects/tranquil_living_2.jpg
// module id = 530
// module chunks = 0